import { createContext, useState } from "react";
import { Dropdown } from "../components/Dropdown";
import { StyleProp, ViewStyle } from "react-native";
import { IconName } from "../components/Icon";

export type DropdownItemsType = {
    icon?: IconName;
    color?: string;
    label: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onClick: (data?: any) => void | Promise<void>;
    selected?: boolean;
    style?: StyleProp<ViewStyle>;
    testID?: string;
    multiline?: boolean;
};

export type DropdownConfigType = {
    items: DropdownItemsType[] | null;
    position?: {
        x: number;
        y: number;
        width: number;
        maxHeight: number;
        pressX?: number;
        pressY?: number;
        dropdownPosition: "left" | "right";
    } | null;
    keepOpen?: boolean;
    onBlur?: () => void;
};

interface DropdownContextInterface {
    setDropdownConfig: (config: DropdownConfigType) => void;
}

export const DropdownManagerContext = createContext<DropdownContextInterface>({
    setDropdownConfig: () => {},
});

type DropdownManagerProps = {
    children: React.ReactNode;
};

const DropdownManager = ({ children }: DropdownManagerProps) => {
    const [config, setDropdownConfig] = useState<DropdownConfigType>({
        items: null,
        position: null,
        keepOpen: false,
    });

    return (
        <DropdownManagerContext.Provider
            value={{
                setDropdownConfig: (e) => {
                    if (!config.position) {
                        setDropdownConfig({ ...config, ...e });
                    }
                },
            }}
        >
            {children}
            {config.items && config.position && (
                <Dropdown
                    onClose={() => {
                        setDropdownConfig({ items: null, position: null, keepOpen: false });
                    }}
                    onBlur={() => {
                        config.onBlur?.();
                    }}
                    items={config.items}
                    position={config.position}
                    keepOpen={config.keepOpen}
                />
            )}
        </DropdownManagerContext.Provider>
    );
};

export default DropdownManager;
